<template>
    <div class="dynamic-wrap">
        <div class="left-container">
            <div class="top-container">
                <div class="bubble-wrap">
                    <img src="../../../assets/images/databoard/bubble-bg.png" width="100%" height="100%">
                </div>
                <div class="bottom-circle">
                    <div class="circular1">
                        <img src="../../../assets/images/databoard/1.png" width="100%" height="100%">
                    </div>
                    <div class="circular2">
                        <img src="../../../assets/images/databoard/2.png" width="100%" height="100%">
                    </div>
                    <div class="circular1">
                        <img src="../../../assets/images/databoard/1.png" width="100%" height="100%">
                    </div>
                    <div class="circular3">
                        <img src="../../../assets/images/databoard/3.png" width="100%" height="100%">
                    </div>
                    <div class="circular4">
                        <img src="../../../assets/images/databoard/4.png" width="100%" height="100%">
                    </div>
                    <div class="circular5">
                        <img src="../../../assets/images/databoard/5.png" width="100%" height="100%">
                    </div>
                </div>
                <div class="item bubble1">
                    <span>研讨</span>
                </div>
                <div class="item bubble2">
                    <span>备课</span>
                </div>
                <div class="item bubble5">
                    <span>资源</span>
                </div>
                <div class="item bubble4">
                    <span>互动</span>
                </div>
            </div>
            <div class="bottom-container">

            </div>
        </div>
        <div class="right-container">
            <ul id="dynamic-ul" @mouseover="hoverEvent" @mouseout="mouseleaveEvent" ref="dynamicUl">
                <template v-for="item in renderDynamicList">
                    <li :style="{                                         top: item.top                                         +                                         'px',                                         left: item.left                                         +                                         'px',                                         color:                                         item.color                                         }"
                        v-on:click="lookTeaDynamic(item)">{{                                         item.operation                                         }}
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { findHomeworkInfo, findResourceInfo, findInterInfo, findUserInfo } from "../../../service/api.js";

export default {
    name: "tea-dynamic",
    props: {
        dynamicData: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            dynamicList: [],
            top: [],
            left: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            color: ['#FFF', '#0EFCFF', '#4889FF', '#FAE17C'],
            scrollInterval: {},//动态滚动区间,
            scrollIngDynamicList: [],
            timer: null,
            hwUserSubjectId: null,
            channel: process.env.VUE_APP_CHANNEL,
        }
    },
    computed: {
        ...mapGetters([
            'homeWorkReportPath'
        ]),
        renderDynamicList: {
            get: function () {
                if (this.dynamicData.length > 0) {
                    return this.initDynamicData(this.dynamicData);
                }
            }
        }
    },
    methods: {
        /**
         * 初始化实时动态top,left,color
         */
        initDynamicData(list) {
            let _this = this;
            let minTop = 45;
            let newList = [];
            //判断动态是否小于9条 小于9条则复制3份 实现从底部滚动的效果
            if (list.length < 9) {
                for (let i = 0; i < 3 * list.length; i++) {
                    let dynamicObj = {};
                    dynamicObj.id = list[i % list.length].id;
                    dynamicObj.operation = list[i % list.length].operation;
                    dynamicObj.operation_time = list[i % list.length].operation_time;
                    dynamicObj.realname = list[i % list.length].realname;
                    dynamicObj.type = list[i % list.length].type;
                    dynamicObj.tempIndex = i;
                    newList.push(dynamicObj);
                }
            } else {
                newList = list;
            }

            for (let i = 1; i <= newList.length; i++) {
                let curTop = i * minTop;
                _this.top.push(curTop);

            }
            for (let j = 0; j < newList.length; j++) {
                var leftIndex = parseInt(_this.left.length * Math.random());
                newList[j]['left'] = _this.left[leftIndex];
                var colorIndex = parseInt(4 * Math.random());
                newList[j]['top'] = _this.top[j];
                newList[j]['color'] = _this.color[colorIndex];
            }

            _this.scrollInterval.minTop = minTop;
            _this.scrollInterval.maxTop = minTop * newList.length - 30;

            this.timer = setInterval(_this.dynamicScroll, 20);
            return newList;

        },
        /**
         * 鼠标悬停停止滚动
         */
        hoverEvent() {
            clearInterval(this.timer);
        },
        /**
         * 鼠标离开继续滚动
         */
        mouseleaveEvent() {
            this.timer = setInterval(this.dynamicScroll, 20);
        },
        /**
         * 动态滚动效果
         */
        dynamicScroll() {
            let _this = this;
            let arr = this.$refs.dynamicUl.children;
            for (var i = 0; i < arr.length; i++) {
                if (_this.scrollIngDynamicList.length != arr.length) {
                    _this.scrollIngDynamicList[i] = arr[i].offsetTop;

                }
                arr[i].style.top = _this.scrollIngDynamicList[i] + "px";
                _this.scrollIngDynamicList[i]--;
                if (_this.scrollIngDynamicList[i] < -30) {
                    _this.scrollIngDynamicList[i] = _this.scrollInterval.maxTop;
                }
            }
        },
        /**
         * 点击事实动态查看详情
         */
        lookTeaDynamic(dynamicObj) {
            if (this.channel != 'sy') {
                //type:1：作业  2：资源  3：互动
                if (dynamicObj.type === 1) {
                    //获取作业详情
                    this.getHomeWorkInfo(dynamicObj.id);
                } else if (dynamicObj.type === 2) {
                    //获取资源详情
                    this.getResourceInfo(dynamicObj.id);
                } else if (dynamicObj.type === 3 || dynamicObj.type === 4) {
                    //获取互动详情
                    this.getInterInfo(dynamicObj.id);
                }
            }

        },
        /**
         * 获取作业详情
         */
        async getHomeWorkInfo(id) {
            let _this = this;
            let params = {
                workId: id,
            }
            let homeworkInfo = await findHomeworkInfo(params).catch(function (error) {
                _this.$Message.error(error.message);
            });
            if (homeworkInfo != null && homeworkInfo.id != undefined) {
                //获取用户姓名
                _this.findUserSubjectByUserId(homeworkInfo.teaid, homeworkInfo.id, homeworkInfo.title, homeworkInfo.hwtype, homeworkInfo.hwtypecode);
            } else {
                this.$Message.error("暂未找到该作业信息！");
                return;
            }
        },
        /**
         * 点击查看作业报告
         */
        lookWorkReport(userId, homeworkId, homeworkName, hwType, hwTypeCode) {
            let reportUrl = "";
            //答题卡
            if (hwType == 0) {
                reportUrl = this.homeWorkReportPath + '/report/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
            } else if (hwType == 1) {

                if (hwTypeCode == '103') {
                    //菁优题库
                    reportUrl = this.homeWorkReportPath + '/jingyouReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                } else if (hwTypeCode == '104' || hwTypeCode == '110') {
                    //校本题库
                    reportUrl = this.homeWorkReportPath + '/xbReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                } else if (hwTypeCode == '108') {
                    //学科网
                    reportUrl = this.homeWorkReportPath + '/xkwReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                } else {
                    //题库
                    reportUrl = this.homeWorkReportPath + '/questionBankReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                }
            }
            window.open(reportUrl, "_blank");
        },
        /**
         * 根据用户id查询学科id
         */
        async findUserSubjectByUserId(userId, homeworkId, homeworkName, hwType, hwTypeCode) {
            let _this = this;
            let userParam = {
                userId: userId
            };

            let userData = await findUserInfo(userParam).catch(function (error) {
                _this.$Message.error(error.message);
            });

            _this.hwUserSubjectId = userData.subjectid;
            //点击查看作业报告
            _this.lookWorkReport(userId, homeworkId, homeworkName, hwType, hwTypeCode);
        },
        /**
         * 获取资源详情
         */
        async getResourceInfo(id) {
            let _this = this;
            let params = {
                id: id
            }
            let resourceInfo = await findResourceInfo(params).catch(function (error) {
                _this.$Message.error(error.message);
            });
            if (resourceInfo != null) {
                //通知父页面
                _this.$emit(
                    "openPreview",
                    resourceInfo.resultUrl,
                    resourceInfo.imgCount, resourceInfo.fileType
                );
            } else {
                this.$Message.error("暂未找到该资源信息！");
                return;
            }
        },
        /**
         * 获取课堂互动详情
         */
        async getInterInfo(id) {
            let _this = this;
            let params = {
                id: id
            }
            let interInfo = await findInterInfo(params).catch(function (error) {
                _this.$Message.error(error.message);
            });
            if (interInfo != null) {
                //通知父页面
                _this.$emit(
                    "lookInterInfo",
                    interInfo
                );
            } else {
                this.$Message.error("暂未找到该课堂互动信息！");
                return;
            }
        }
    },
    destroyed() {
        //组件销毁时手动销毁事件
        clearInterval(this.timer);
    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.bubble1 {
    background-image: url("../../../assets/images/databoard/bubble-small.png");
    background-size: 100% 100%;
}

.bubble2 {
    background-image: url("../../../assets/images/databoard/bubble-big.png");
    background-size: 100% 100%;
}

.bubble3 {
    background-image: url("../../../assets/images/databoard/bubble-middle.png");
    background-size: 100% 100%;
}

.bubble4 {
    background-image: url("../../../assets/images/databoard/bubble-small.png");
    background-size: 100% 100%;
}

.bubble5 {
    background-image: url("../../../assets/images/databoard/bubble-small.png");
    background-size: 100% 100%;
}
</style>

